import { useState, useCallback, useEffect } from 'react';

interface UseRemarkModalProps {
  defaultRemark?: string;
}

interface UseRemarkModalReturn {
  isOpen: boolean;
  remark: string;
  handleToggle: () => void;
  handleSave: (newRemark: string) => void;
  handleClose: () => void;
  modalProps: {
    close: () => void;
    isActive: boolean;
    handleSave: (newRemark: string) => void;
    data: {
      title: string;
      body: string;
    };
  };
}

const useRemarkModal = ({ defaultRemark = '' }: UseRemarkModalProps = {}): UseRemarkModalReturn => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [remark, setRemark] = useState<string>(defaultRemark);
  useEffect(() => {
    setRemark(defaultRemark);
  }, [defaultRemark]);
  const handleToggle = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleSave = useCallback((newRemark: string) => {
    setRemark(newRemark);
    setIsOpen(false);
  }, []);

  const modalProps = {
    close: handleToggle,
    isActive: true,
    handleSave,
    data: {
      title: 'הערות',
      body: remark
    }
  };

  return {
    isOpen,
    remark,
    handleToggle,
    handleSave,
    handleClose,
    modalProps
  };
};

export default useRemarkModal; 